import styled from 'styled-components';

export const ArticleProductContainer = styled.div`
  position: relative;
  margin-top: ${(props) => (props.fromBabyNames ? '24px' : '0')};
  padding: ${(props) => (props.fromBabyNames ? '0 0 0 12px' : '0')};
  @media (max-width: 720px) {
    padding: ${(props) => (props.fromBabyNames ? '0' : '0 12px 0 0')};
  }
  .bestSellerContainer {
    display: flex;
    padding-left: 4px;
    flex-wrap: wrap;
  }
`;

export const Title = styled.h1`
  padding: ${(props) => (props.fromBabyNames ? '0' : '0 10px 10px')};
  text-align: ${(props) => (props.fromBabyNames ? 'left' : 'center')};
  font-size: ${(props) =>
    props.fromBabyNames ? 'clamp(16px,2vw,22px)' : 'clamp(18px, 2vw, 22px)'};
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 87%);
  letter-spacing: ${(props) => (props.fromBabyNames ? '0' : '3px')};
  @media (max-width: 720px) {
    padding-bottom: 16px;
    padding-left: ${(props) => (props.fromBabyNames ? '12px' : '0')};
  }
`;
